export default {"src":"/_next/static/media/edit--small.70bc7f8f.svg","height":16,"width":16};